/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const EmployeeCreatePage = lazyLoad(
  () => import('./index'),
  module => module.EmployeeCreatePage
);
